import React from 'react';

interface SettingToggleRowProps {
    title: string;
    description?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    /** Extra left padding for nested/sub rows. */
    indented?: boolean;
}

const SettingToggleRow: React.FC<SettingToggleRowProps> = ({
    title,
    description,
    checked,
    onChange,
    disabled = false,
    indented = false,
}) => (
    <div className="set-row" style={indented ? { paddingLeft: '62px' } : undefined}>
        <div className="set-row__text">
            <div className="set-row__name">{title}</div>
            {description && <div className="set-row__sub">{description}</div>}
        </div>
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={title}
            className={`toggle-switch ${checked ? 'active' : ''}`}
            onClick={() => !disabled && onChange(!checked)}
            disabled={disabled}
            style={{ border: 'none', padding: 0 }}
        >
            <span className="toggle-switch-thumb" />
        </button>
    </div>
);

export default SettingToggleRow;
